import { notify } from '../../actions/notifications';
import { fetchRecommendationsToggleFavorite } from '../../actions/recommendations';
import {
  TDeleteOfferFromFavoritesResponse,
  fetchDeleteOfferFromFavorites,
} from '../../repositories/favorites/v1/delete-offer-from-favorites';
import { ENotificationStyle } from '../../types/notifications';
import { TRecommendation } from '../../types/recommendation';
import { TThunkAction } from '../../types/redux';

export const deleteFromFavorite =
  ({ dealType, offerId, entityType }: TRecommendation): TThunkAction<Promise<void>> =>
  async (dispatch, _, { httpApi, logger }) => {
    dispatch(fetchRecommendationsToggleFavorite({ offerId, isFavorite: false }));

    const showError = () => dispatch(notify('Не удалось удалить рекомендацию из избранного', ENotificationStyle.Error));

    try {
      const { statusCode, response }: TDeleteOfferFromFavoritesResponse = await fetchDeleteOfferFromFavorites({
        httpApi,
        parameters: {
          dealType,
          entityId: offerId,
          entityType,
        },
      });

      if (statusCode !== 200) {
        dispatch(fetchRecommendationsToggleFavorite({ offerId, isFavorite: true }));

        showError();
        logger.warning(response.message || 'Fail to remove recommendation from favorites');
      }
    } catch (e) {
      dispatch(fetchRecommendationsToggleFavorite({ offerId, isFavorite: true }));

      showError();
      logger.error(e, {
        description: 'Fail to remove recommendation from favorites',
      });
    }
  };
